import { useEffect } from 'react'
import { useRouter } from 'next/router'
import Script from 'next/script'

import { analytics } from '@/constants/analytics'

declare global {
    interface Window {
        fbq?: (...args: unknown[]) => void
        twq?: (...args: unknown[]) => void
        gtag?: (...args: unknown[]) => void
        dataLayer?: unknown[]
    }
}

// Global marketing/analytics tags: Meta Pixel, X (Twitter), and the GA4 Google tag.
// The inline snippets fire a pageview on first load; client-side navigations are
// tracked manually via the router event below.
export function Analytics() {
    const router = useRouter()

    useEffect(() => {
        const onRouteChange = (url: string) => {
            window.fbq?.('track', 'PageView')
            window.gtag?.('config', analytics.gaMeasurementId, { page_path: url })
        }

        router.events.on('routeChangeComplete', onRouteChange)

        return () => router.events.off('routeChangeComplete', onRouteChange)
    }, [router.events])

    return (
        <>
            {/* Meta (Facebook) Pixel */}
            <Script id='meta-pixel' strategy='afterInteractive'>
                {`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${analytics.metaPixelId}');
fbq('track', 'PageView');`}
            </Script>

            {/* X (Twitter) conversion tracking */}
            <Script id='twitter-pixel' strategy='afterInteractive'>
                {`!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
},s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
twq('config','${analytics.twitterPixelId}');`}
            </Script>

            {/* Google tag (GA4) */}
            <Script
                src={`https://www.googletagmanager.com/gtag/js?id=${analytics.gaMeasurementId}`}
                strategy='afterInteractive'
            />
            <Script id='google-gtag' strategy='afterInteractive'>
                {`window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${analytics.gaMeasurementId}');`}
            </Script>
        </>
    )
}
